// src/components/common/ReviewCardSkeleton.tsx

// Define uma interface para as props, declarando que 'className' é uma string opcional
interface SkeletonProps {
    className?: string;
}

export function ReviewCardSkeleton({ className = '' }: SkeletonProps) {
    return (
        // A 'className' recebida é adicionada ao final da lista de classes do div principal
        <div className={`bg-background p-6 rounded-lg shadow-subtle relative overflow-hidden ${className}`}>
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer"></div>
            <div className="flex gap-1 mb-4">
                <div className="w-5 h-5 bg-gray-200 rounded-full"></div>
                <div className="w-5 h-5 bg-gray-200 rounded-full"></div>
                <div className="w-5 h-5 bg-gray-200 rounded-full"></div>
                <div className="w-5 h-5 bg-gray-200 rounded-full"></div>
                <div className="w-5 h-5 bg-gray-200 rounded-full"></div>
            </div>
            <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
            <div className="h-4 bg-gray-200 rounded w-5/6"></div>
            <div className="h-4 bg-gray-200 rounded w-1/4 mt-4 ml-auto"></div>
        </div>
    );
}